<template>
  <div class="bar-configurator container-bar" @touchmove="scrollStatus($event);" @touchend="scrollStatusOut($event);">
     <transition name="fade">
      <div class="backdrop-bar" v-if="changeMode"></div>
        </transition>
 
    <p class="f-34 bar-ttl">{{$fn.tr('შეადგინე შენი მენიუ და გამოთვალე რამდენს დალევთ')}}</p>
    <svg
      class="bar-ttl-line"
      xmlns="http://www.w3.org/2000/svg"
      width="1110"
      height="1"
      viewBox="0 0 1110 1"
    >
      <line
        id="Line_48"
        data-name="Line 48"
        x2="1110"
        transform="translate(0 0.5)"
        fill="none"
        stroke="#3a5aa7"
        stroke-width="1"
        opacity="0.3"
      />
    </svg>

    <div id="fixed-target"></div>
        <BarOrderModal :total_price="totalDrinkPrice" :orderedCocktails="orderedVals" />
    <div class="suggestion-box-outer-mobile">

 <div class="cocktail-total-price mobile">
                
      
            </div>

  

    </div>
   
    <div class="calc-wrapper">
   
      <div class="suggestion-box lg" data-scroll data-scroll-sticky data-scroll-target="#fixed-target">
        <div class="drink-div">
          
          <span class="f-21 light-italic" v-if="windowWidth >= 768">{{$fn.tr('დრინქების რაოდენობა')}}</span>
          <span class="f-21 light-italic" v-if="windowWidth <= 767">{{$fn.tr('დრინქები')}}</span>
          <input type="number" id="suggestion-input" class="change-mode-input" v-if="changeMode" :value="this.guestsIntensity" @keyup.enter="changeTotalVal()">
          <span class="f-55 val" v-else>{{ this.guestsIntensity }}</span>
          <span class="underline light-italic pointer white f-16" v-if="!changeMode" @click="toggleMode">{{$fn.tr('ცვლილება')}}</span>
          <div class="keep-or-discard" v-if="changeMode">
          <span class="underline light-italic pointer white f-16 keep" @click="changeTotalVal(); toggleMode();">{{$fn.tr('შენახვა')}}</span>
          <span class="underline light-italic pointer white f-16 discard" @click="toggleMode">{{$fn.tr('გაუქმება')}}</span>

          </div>
        </div>
        <div class="price-div">
          <span class="f-21 light-italic">{{$fn.tr('ფასი')}}&nbsp;(₾)</span>
      
          <span class="f-55 val" v-if="totalDrinkPrice > 0">{{ totalDrinkPrice }}</span>
          <span class="f-55 val" v-else>. . .</span>
        </div>
          <div class="bar-order pointer" @click="toggleBarOrderModal"><span class="f-34">{{$fn.tr('შეკვეთა')}}</span></div>

              <div class="note-wrapper">
            <svg :class="{white: changeMode}" id="fi-sr-info" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g id="Group_1872" data-name="Group 1872">
    <path id="Path_3847" data-name="Path 3847" d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM10,4.167a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,10,4.167ZM9.167,8.333H10A1.667,1.667,0,0,1,11.667,10v5A.833.833,0,0,1,10,15V10H9.167a.833.833,0,0,1,0-1.667Z" fill="#101820"/>
  </g>
</svg>

              <span class="note light-italic" :class="{white: changeMode}">{{$fn.tr(`შეკვეთის ღირებულება უნდა შეადგენდეს მინიმუმ`)}}&nbsp;<span class="alert bold-italic">{{$fn.tr('600 ლარს')}}</span></span>
          </div>
      </div>
      
       

      

      <div class="question-1 question-wrapper">
        <p class="bold-italic f-21">1) {{$fn.tr('რამდენი ადამიანი ესწრება ღონისძიებას?')}}</p>
        <div class="range-wrapper w-tooltip guests_num">
          <div class="track-wrapper">
            <span class="moved-track w-helper"></span>
          </div>
          <div class="label-wrapper">
          
             <div class="tool-tip w-helper">
            <span class="bold">{{ this.guestVal }}</span>
          </div>
          
          </div>

        
          <svg @click="decrementQ($event)" class="question-minus" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <g id="Group_3335" data-name="Group 3335" transform="translate(-1120 -3018)">
    <rect id="Rectangle_2718" data-name="Rectangle 2718" width="48" height="48" transform="translate(1120 3018)" fill="#fff" opacity="0"/>
    <g id="Group_2154" data-name="Group 2154" transform="translate(270.966 4173.357) rotate(-90)">
      <path id="Path_3800" data-name="Path 3800" d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z" transform="translate(1132.357 866.034) rotate(90)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
    </g>
  </g>
</svg>

          <input
            type="range"
            min="10"
            max="2000"
            value="10"
            class="slider"
            v-model="guestVal"
            id="myRange"
            @input="
              totalFuncGuest();
              totalFuncInt();
              yayOrNay();
            "
          />
          <svg @click="incrementQ($event)" class="question-plus" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <g id="Group_3337" data-name="Group 3337" transform="translate(-1116 -3014)">
    <rect id="Rectangle_2718" data-name="Rectangle 2718" width="48" height="48" transform="translate(1116 3014)" fill="#fff" opacity="0"/>
    <g id="Group_2154" data-name="Group 2154" transform="translate(266.966 4169.128) rotate(-90)">
      <path id="Path_219" data-name="Path 219" d="M.571,2.322c2.57.051,5.094-.545,7.658-.612,1.568-.041,3.276.213,4.808-.324.381-.134.849-.39.834-.921l0-.065c-.014-.513-.836-.494-1.409-.166C11.066.609,9.482.278,8.078.367,5.818.51,3.58,1,1.312.951.531.936-.751,2.3.571,2.322Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1137.965, 875.163)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
      <path id="Path_3800" data-name="Path 3800" d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z" transform="translate(1132.357 866.034) rotate(90)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
    </g>
  </g>
</svg>
        
        </div>
          <div class="change-box-outer">
            <div class="change-box">
              <input
                type="number"
                class="slider-helper"
                v-model="guestVal"
                value="10"
                 min="10"
            max="2000"
                   @input="
              totalFuncGuest();
              totalFuncInt();
              yayOrNay();
            "
                
              />
            </div>
        </div>
      </div>

      <div class="question-2 question-wrapper">
        <p class="bold-italic f-21">{{$fn.tr('2) რამდენი ხანი გრძელდება ღონისძიება?')}}</p>
        <div class="range-wrapper w-tooltip has_q2">
          <div class="track-wrapper">
            <span class="moved-track"></span>
          </div>
          <div class="label-wrapper">
             <div class="tool-tip">
            <span class="bold">{{ this.durValOutput }}</span>
          </div>
            <span class="f-21 regular" :class="{ active: durValOutput == 1 }"
              >{{$fn.tr('1 სთ')}}</span
            >
            <!-- <span class="f-21 regular" :class="{ active: durValOutput == 6 }"
              >{{$fn.tr('6 სთ')}}</span
            > -->
            <span class="f-21 regular" :class="{ active: durValOutput == 12 }"
              >{{$fn.tr('12 სთ')}}</span
            >
          </div>
         
                 <svg @click="decrementQ2($event)" class="question-minus" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <g id="Group_3335" data-name="Group 3335" transform="translate(-1120 -3018)">
    <rect id="Rectangle_2718" data-name="Rectangle 2718" width="48" height="48" transform="translate(1120 3018)" fill="#fff" opacity="0"/>
    <g id="Group_2154" data-name="Group 2154" transform="translate(270.966 4173.357) rotate(-90)">
      <path id="Path_3800" data-name="Path 3800" d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z" transform="translate(1132.357 866.034) rotate(90)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
    </g>
  </g>
</svg>
          <input
            type="range"
            min="1"
            max="12"
            value="1"
            class="slider"
            v-model="durVal"
            id="myRange2"
            @input="
              totalFuncGuest();
              totalFuncInt();
              yayOrNay();
            "
          />
                <svg @click="incrementQ2($event)" class="question-plus" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <g id="Group_3337" data-name="Group 3337" transform="translate(-1116 -3014)">
    <rect id="Rectangle_2718" data-name="Rectangle 2718" width="48" height="48" transform="translate(1116 3014)" fill="#fff" opacity="0"/>
    <g id="Group_2154" data-name="Group 2154" transform="translate(266.966 4169.128) rotate(-90)">
      <path id="Path_219" data-name="Path 219" d="M.571,2.322c2.57.051,5.094-.545,7.658-.612,1.568-.041,3.276.213,4.808-.324.381-.134.849-.39.834-.921l0-.065c-.014-.513-.836-.494-1.409-.166C11.066.609,9.482.278,8.078.367,5.818.51,3.58,1,1.312.951.531.936-.751,2.3.571,2.322Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1137.965, 875.163)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
      <path id="Path_3800" data-name="Path 3800" d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z" transform="translate(1132.357 866.034) rotate(90)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
    </g>
  </g>
</svg>
        </div>
      </div>

      <div class="question-3 question-wrapper">
        <p class="bold-italic f-21">{{$fn.tr('3) რამდენად ინტენსიური იქნება სმა?')}}</p>
        <div class="range-wrapper tri_tri">
          <div class="track-wrapper">
            <span class="moved-track"></span>
          </div>
          <div class="label-wrapper">
            <span
              class="f-21 regular"
              :class="{ active: intensityOutput == 'წრუპვა' }"
              >{{$fn.tr('წრუპვა')}}</span
            >
            <span
              class="f-21 regular"
              :class="{ active: intensityOutput == 'მხიარულება' }"
              >{{$fn.tr('მხიარულება')}}</span
            >
            <span
              class="f-21 regular"
              :class="{ active: intensityOutput == 'გალეშვა' }"
              >{{$fn.tr('გალეშვა')}}</span
            >
          </div>
                         <svg @click="decrementQ3($event)" class="question-minus" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <g id="Group_3335" data-name="Group 3335" transform="translate(-1120 -3018)">
    <rect id="Rectangle_2718" data-name="Rectangle 2718" width="48" height="48" transform="translate(1120 3018)" fill="#fff" opacity="0"/>
    <g id="Group_2154" data-name="Group 2154" transform="translate(270.966 4173.357) rotate(-90)">
      <path id="Path_3800" data-name="Path 3800" d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z" transform="translate(1132.357 866.034) rotate(90)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
    </g>
  </g>
</svg>
          <input
            type="range"
            min="1"
            max="3"
            value="1"
            class="slider"
            v-model="intensity"
            id="myRange3"
            @input="
              totalFuncGuest();
              totalFuncInt();
              yayOrNay();
            "
          />

                     <svg @click="incrementQ3($event)" class="question-plus" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <g id="Group_3337" data-name="Group 3337" transform="translate(-1116 -3014)">
    <rect id="Rectangle_2718" data-name="Rectangle 2718" width="48" height="48" transform="translate(1116 3014)" fill="#fff" opacity="0"/>
    <g id="Group_2154" data-name="Group 2154" transform="translate(266.966 4169.128) rotate(-90)">
      <path id="Path_219" data-name="Path 219" d="M.571,2.322c2.57.051,5.094-.545,7.658-.612,1.568-.041,3.276.213,4.808-.324.381-.134.849-.39.834-.921l0-.065c-.014-.513-.836-.494-1.409-.166C11.066.609,9.482.278,8.078.367,5.818.51,3.58,1,1.312.951.531.936-.751,2.3.571,2.322Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1137.965, 875.163)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
      <path id="Path_3800" data-name="Path 3800" d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z" transform="translate(1132.357 866.034) rotate(90)" fill="#f49cb8" stroke="#f49cb8" stroke-width="2"/>
    </g>
  </g>
</svg>
        </div>
      </div>

      <div class="question-4 yay-or-nay">
        <p class="bold-italic f-21">
          {{$fn.tr('4) იქნება თუ არა ღონისძიებაზე სხვა სასმელიც?')}}
        </p>
        <div class="labels-container">
          <label class="container" :class="{ active: picked == 'კი' }">
            <p>{{$fn.tr('სხვა სასმელი - კი')}}</p>
            <input
              type="radio"
              v-model="picked"
              value="კი"
              name="radio"
              @change="
                totalFuncGuest();
                totalFuncInt();
                yayOrNay();
              "
            />
            <span class="checkmark"></span>
          </label>
          <label class="container" :class="{ active: picked == 'არა' }">
            <p>{{$fn.tr('სხვა სასმელი - არა')}}</p>
            <input
              type="radio"
              v-model="picked"
              value="არა"
              name="radio"
              @change="
                totalFuncGuest();
                totalFuncInt();
                yayOrNay();
              "
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <!-- <h2>{{this.picked}}</h2> -->
      </div>

      <div class="result-wrapper">
        <!-- <h2>დრინქები დროის მიხედვით: {{ this.guests}}</h2> -->
        <p class="bold-italic f-21">
          {{$fn.tr('5) გადაანაწილე დრინქები სასურველი რაოდენობით')}}
        </p>

        <p class="f-21 secondary-ttl">{{$fn.tr('დრინქების გადანაწილება')}}</p>
        <p class="light-italic instruction">
          <!-- მოეჭიდოს გეშინოდა ვაყურყუმელავებთ მოხუცები, მაესტროზე კომიტეტის, რამემ
          სტროფამდე კისრიდან. იქითკენ მაესტროზე სირცხვილს დაკეტილიდან შურით თქმა
          ევედრებოდნენ გაიღვიძა უშფოთველად წარმოიდგინეს დაიბერტყა განათებას
          ინგლისელთა რატომღაც ნეორეალიზმის. ვუამბე ტლანქსა რჩევამ ჯოჯო,
          გამობრუნდებოდნენ, შურით კონერსმა. -->
          {{$store.state.main.indx.widgets.configure_drinks.text}}
        </p>
      </div>








      <div class="drinks-wrapper">
        <div v-for="(drink, index) in _contentData" :key="index" class="drink" >
          <div class="input-wrapper">
            <svg
              @click="increment($event); calcTotalDrinkPrice(drink.price);
              getOrderVals(drinkAmount[index], drink.title, drink.id, Number.parseFloat(drink.price * drinkAmount[index]).toFixed(2));
              "
              class="plus pointer"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
            >
              <g
                id="Group_3330"
                data-name="Group 3330"
                transform="translate(-1116 -3014)"
              >
                <rect
                  id="Rectangle_2718"
                  data-name="Rectangle 2718"
                  width="48"
                  height="48"
                  transform="translate(1116 3014)"
                  fill="#fff"
                  opacity="0"
                />
                <g
                  id="Group_2154"
                  data-name="Group 2154"
                  transform="translate(266.966 4169.128) rotate(-90)"
                >
                  <path
                    id="Path_219"
                    data-name="Path 219"
                    d="M.571,2.322c2.57.051,5.094-.545,7.658-.612,1.568-.041,3.276.213,4.808-.324.381-.134.849-.39.834-.921l0-.065c-.014-.513-.836-.494-1.409-.166C11.066.609,9.482.278,8.078.367,5.818.51,3.58,1,1.312.951.531.936-.751,2.3.571,2.322Z"
                    transform="matrix(-0.998, -0.07, 0.07, -0.998, 1137.965, 875.163)"
                    fill="#f49cb8"
                    stroke="#f49cb8"
                    stroke-width="2"
                  />
                  <path
                    id="Path_3800"
                    data-name="Path 3800"
                    d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z"
                    transform="translate(1132.357 866.034) rotate(90)"
                    fill="#f49cb8"
                    stroke="#f49cb8"
                    stroke-width="2"
                  />
                </g>
              </g>
            </svg>
            <div class="inner-wrapper">
                 <div class="track-wrapper">
            <span class="moved-track"></span>
          </div>
     <input
              type="range"
              min="0"
              :max="guestsIntensityDup"
              value="1"
              :drink-amount="drinkAmount[index]"
              :drink-title="drink.title"
              :drink-price="Number.parseFloat(drink.price * drinkAmount[index]).toFixed(2)"
              class="bottle-slider slider"
              @input="calcBottles($event); calcTotalDrinkPrice(drink.price); 
              getOrderVals(drinkAmount[index], drink.title, drink.id, Number.parseFloat(drink.price * drinkAmount[index]).toFixed(2));"
              @change="preventBottles($event)"
              @click="getOldVal($event)"
             
              :ref="'cocktailVal' + drink.id"
            />


            </div>
         
            <div class="minus-wrapper">
              <svg
            @click="decrement($event); calcTotalDrinkPrice(drink.price);
              getOrderVals(drinkAmount[index], drink.title, drink.id, Number.parseFloat(drink.price * drinkAmount[index]).toFixed(2));
            "
              class="minus pointer"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
            >
              <g
                id="Group_3331"
                data-name="Group 3331"
                transform="translate(-1120 -3018)"
              >
                <rect
                  id="Rectangle_2718"
                  data-name="Rectangle 2718"
                  width="48"
                  height="48"
                  transform="translate(1120 3018)"
                  fill="#fff"
                  opacity="0"
                />
                <g
                  id="Group_2154"
                  data-name="Group 2154"
                  transform="translate(270.966 4173.357) rotate(-90)"
                >
                  <path
                    id="Path_3800"
                    data-name="Path 3800"
                    d="M.577,2.33c2.594.056,5.141-.544,7.729-.607,1.583-.039,3.306.221,4.852-.321.384-.135.857-.393.841-.93l0-.065c-.015-.52-.845-.5-1.423-.17C11.168.612,9.569.275,8.152.363,5.871.5,3.613.993,1.323.943.535.927-.757,2.3.577,2.33Z"
                    transform="translate(1132.357 866.034) rotate(90)"
                    fill="#f49cb8"
                    stroke="#f49cb8"
                    stroke-width="2"
                  />
                </g>
              </g>
            </svg>
             <span class="cocktail-amount bold-italic f-16">{{ drinkAmount[index] }}x</span>
            </div>
            

           
               <div class="cocktail-total-price" v-if="windowWidth >= 768">
                 <span class="f-16 light-italic">{{$fn.tr('დარჩენილია')}}:</span>
                 <div class="inner">
                   
                         <span class="f-21 bold-italic">{{  guestsIntensity - sum > 0 ? guestsIntensity - sum : 0 }}</span>  
                         <span class="f-13 light-italic"> {{$fn.tr('დრინქი')}} </span>
                 </div>
      
            </div>
          </div>
          <div class="bottle-wrapper">
            <img :src="drink.images[0].url" alt="" />
            <div class="cocktail-price-div">
              <span class="f-16 bold-italic">{{ Number.parseFloat(drink.price * drinkAmount[index]).toFixed(2)}} ₾</span>
            </div>
          </div>

          <div class="desc-box">
            <div class="ttl-wrapper">
              <span class="cocktail-ttl f-21">{{ drink.title }}</span>
              <span class="bold-italic f-16"
                >{{ drink.price }} ₾ / 1x</span
              >
            </div>

            <svg
              class="line"
              xmlns="http://www.w3.org/2000/svg"
              width="540"
              height="1"
              viewBox="0 0 540 1"
            >
              <path
                id="Path_3896"
                data-name="Path 3896"
                d="M35.552,7.1c155.324-.392,312.635.035,468.692-.215,39.558-.063,62.615-.849,9.343-.763-156.1.251-313.075-.178-468.692.215C6.23,6.431-17.507,7.231,35.552,7.1Z"
                transform="translate(-4.75 -6.112)"
                fill="#3a5aa7"
                opacity="0.3"
              />
            </svg>
            <div class="cocktail-properties">
              <div class="volume-div property" v-for="(_ch, index) in drink.newIngredients.newArr" :key="index">
                <span class="light-italic f-16" v-if="$store.state.main.locale == 'ge'">{{_ch.front_title_ge}}</span>
                <span class="bold-italic f-16" v-if="$store.state.main.locale == 'ge'">{{_ch.descr_ge}}</span>
                <span class="light-italic f-16" v-if="$store.state.main.locale == 'en'">{{_ch.front_title_en}}</span>
                <span class="bold-italic f-16" v-if="$store.state.main.locale == 'en'">{{_ch.descr_en}}</span>
              </div>
<!-- 
              <div class="alco-div property">
                <span class="light-italic f-16">{{$fn.tr('ალკოჰოლი')}}</span>
                <span class="bold-italic f-16">{{getAlcohol(index)}}</span>
              </div>

              <div class="air-div property">
                <span class="light-italic f-16">{{$fn.tr('ბუნებრივი გაზი')}}</span>
                <span class="bold-italic f-16">{{getGas(index)}}</span>
              </div> -->
            </div>

            <svg
              class="line"
              xmlns="http://www.w3.org/2000/svg"
              width="540"
              height="1"
              viewBox="0 0 540 1"
            >
              <path
                id="Path_3896"
                data-name="Path 3896"
                d="M35.552,7.1c155.324-.392,312.635.035,468.692-.215,39.558-.063,62.615-.849,9.343-.763-156.1.251-313.075-.178-468.692.215C6.23,6.431-17.507,7.231,35.552,7.1Z"
                transform="translate(-4.75 -6.112)"
                fill="#3a5aa7"
                opacity="0.3"
              />
            </svg>
            <div class="content-wrapper" v-if="drink.newIngredients2.newArr.length > 0">
              <span class="bold-italic f-16">{{$fn.tr('შემადგენლობა')}}</span>
              <div class="content-wrapper__inner" v-if="$store.state.main.locale == 'ge'">

             
              <div class="light-italic f-16" v-for="(pr, index) in drink.newIngredients2.newArr" :key="index">
                    <!-- {{$store.state.main.indx.widgets.bar_cocktail_shemadgenloba.text}} -->
                   <p class="light-italic f-16" v-if="index !== drink.newIngredients2.newArr.length - 1 "> {{pr.title_ge}},</p> 
                   <p class="light-italic f-16" v-else> {{pr.title_ge}}.</p> 
              </div>
               </div>

                 <div class="content-wrapper__inner" v-if="$store.state.main.locale == 'en'">

             
              <div class="light-italic f-16" v-for="(pr, index) in drink.newIngredients2.newArr" :key="index">
                    <!-- {{$store.state.main.indx.widgets.bar_cocktail_shemadgenloba.text}} -->
                   <p class="light-italic f-16" v-if="index !== drink.newIngredients2.newArr.length - 1 "> {{pr.title_en}},</p> 
                   <p class="light-italic f-16" v-else> {{pr.title_en}}.</p> 
              </div>
               </div>
            </div>
            <div class="content-wrapper" v-else>
                <p class="light-italic f-16" >
                    {{$store.state.main.indx.widgets.bar_cocktail_shemadgenloba.text}}
                
              </p>
            </div>
          </div>


          <div class="desc-box sm">
          
              <span class="cocktail-ttl f-21">{{ drink.title }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="84" height="1" viewBox="0 0 84 1">
  <line id="Line_97" data-name="Line 97" x2="84" transform="translate(0 0.5)" fill="none" stroke="#3a5aa7" stroke-width="1" opacity="0.2"/>
</svg>


  <div class="price-wrapper">
    <span class="f-13 light-italic">{{$fn.tr('ფასი')}}</span>
        <span class="bold-italic f-16"
                >{{ drink.price }} ₾ / 1x</span
              >
  </div>
          
      <svg xmlns="http://www.w3.org/2000/svg" width="84" height="1" viewBox="0 0 84 1">
  <line id="Line_97" data-name="Line 97" x2="84" transform="translate(0 0.5)" fill="none" stroke="#3a5aa7" stroke-width="1" opacity="0.2"/>
</svg>
        <portal to="modal">
              <transition name="from-right">
          <ReceiptModalBar :cocktail="drink.allAttributes"  v-if="$store.state.main.receiptActive && activeReceiptIdx == index" />
            </transition>
          </portal>
          <div @click="openReceiptModal(index)" class="f-13 light-italic detail-receipt">{{$fn.tr('დეტალურად')}}</div>
         
       <div class="cocktail-total-price" v-if="windowWidth <= 767">
                 <span class="f-16 light-italic">{{$fn.tr('დარჩენილია')}}:</span>
                 <div class="inner">
                   
                         <span class="f-21 bold-italic">{{  guestsIntensity - sum > 0 ? guestsIntensity - sum : 0 }}</span>  
                         <span class="f-13 light-italic"> {{$fn.tr('დრინქი')}} </span>
                 </div>
      
            </div>
           
          </div>
        </div>
      </div>

   

      <!-- <h2>ბოთლების ლიმიტი:  {{ this.guestsIntensityDup}}</h2>  -->
    </div>
  </div>
</template>

<script>
import BarOrderModal from '@/components/layout/BarOrderModal';
import ReceiptModalBar from '@/components/ReceiptModalBar';
export default {
   components: {
     BarOrderModal,
     ReceiptModalBar
     },
  props: ['contentData'],
 
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      orderedVals: [],
      activeReceiptIdx: null,
      maxBottles2: 0,
      priceArr: [],
      totalDrinkPrice: 0,
      drinkAmount: [],
      orderedCocktails: [],
      drinks: [
        {
          drinkName: "ჟუჟუნა",
          drinkImg: "bottlecock.png",
          drinkPrice: 3,
          volume: '650 მლ',
          alcohol: '11.5%',
          air: '2.5 ბარი'
        },
        {
          drinkName: "კენკრიანი ჟუჟუნა",
          drinkImg: "kenkrianijujuna.png",
          drinkPrice: 6,
            volume: '250 მლ',
          alcohol: '4.5%',
          air: '...'
        },
        {
          drinkName: "მიმოზა",
          drinkImg: "mimoza.png",
          drinkPrice: 5.4,
            volume: '350 მლ',
          alcohol: '15.7%',
          air: '1.5 ბარი'
        }
      ],
      labels: [{ l: 10 }, { l: 30 }, { l: 50 }],
      cocktailSlider: "",
      labelActive: true,
      changeMode: false,
      guests: 0,
      guestVal: 10,
      durVal: 1,
      durValOutput: 1,
      intensity: 1,
      intensityOutput: "წრუპვა",
      guestsIntensity: 1,
      picked: "არა",
      // ============ ბოთლების დათვლა
      //drinkVal: 0,
      guestsIntensityDup: 0,
      sum: [],
      oldVal: 0
    };
  },

  mounted() {
    // console.log(this._contentData)
    window.addEventListener("resize", this.resizeWind);
    if(window.innerWidth <= 1100){
      document.querySelector('.suggestion-box.lg').removeAttribute("data-scroll-target");
      document.querySelector('.suggestion-box.lg').removeAttribute("data-scroll-sticky");
      document.querySelector('.suggestion-box.lg').removeAttribute("data-scroll");
    }
    // console.log(this._contentData)
    const allRangesWtoolTip = document.querySelectorAll(
      ".range-wrapper.w-tooltip"
    );
    const movedTrack2 = document.querySelector(".moved-track.w-helper");
        const rangeHelper = document.querySelector(".slider-helper");
          rangeHelper.addEventListener("input", () => {
        this.setLine(rangeHelper, movedTrack2);
      });
      
    const allRanges = document.querySelectorAll(".range-wrapper");
    allRanges.forEach(wrap => {
      const range = wrap.querySelector(".slider");
  
      const movedTrack = wrap.querySelector(".moved-track");

    if(wrap.classList.contains("guests_num"))  range.addEventListener("input", () => {
        this.setLine(range, movedTrack);
      });
      
      if(wrap.classList.contains("guests_num"))  this.setLine(range, movedTrack);

        if(wrap.classList.contains("has_q2"))  range.addEventListener("input", () => {
        this.setLineQ2(range, movedTrack);
      });
      
      if(wrap.classList.contains("has_q2"))  this.setLineQ2(range, movedTrack);


    if(wrap.classList.contains("tri_tri"))  range.addEventListener("input", () => {
        this.setLineTri(range, movedTrack);
      });
      
      if(wrap.classList.contains("tri_tri"))  this.setLineTri(range, movedTrack);

    });


    let drinkSliders = document.querySelectorAll(".drinks-wrapper .inner-wrapper")
    drinkSliders.forEach(d => {
        const range = d.querySelector(".slider");
      const tooltip = d.querySelector(".track-wrapper .moved-track");

          range.addEventListener("input", () => {
        this.setToolTipVert(range, tooltip);
      });
      this.setToolTipVert(range, tooltip);
   
    })

       const tooltip2 = document.querySelector(".label-wrapper .tool-tip.w-helper")
    
        
          rangeHelper.addEventListener("input", () => {
        this.setToolTip(rangeHelper, tooltip2);
      });
      
    allRangesWtoolTip.forEach(wrap => {
      const range = wrap.querySelector(".slider");
      const tooltip = wrap.querySelector(".label-wrapper .tool-tip");
   

      range.addEventListener("input", () => {
        this.setToolTip(range, tooltip);
      });
      this.setToolTip(range, tooltip);
    });

    this.guests = Math.round(this.guestVal * (3 * 1.5));
    this.guestsIntensity = Math.round(this.guestVal * (3 * 1.5) * 0.7);

    this.guestsIntensityDup = this.guestsIntensity;

    this.getEachVal();
  },
  computed: {
    _contentData(){
         let _l = [..._.get(this.contentData, 'data.list')]; 
         for (let i = 0; i < _l.length; i++) {
            let n = []
           let newIngredients = {
             newArr: n,
           }
          
           _l[i].newIngredients = newIngredients;
           
           let attr = _l[i].allAttributes;

           let _attr = this.$store.state.main.indx.attributes.characteristics;
           for (let k = 0; k < _attr.length; k++) {
             for (let j = 0; j < attr.length; j++) {
               if(attr[j] == _attr[k].id){
                n.push(_attr[k])

               }
               
             }
             
           }
         }



          for (let i = 0; i < _l.length; i++) {
            let n = []
           let newIngredients2 = {
             newArr: n,
           }
          
           _l[i].newIngredients2 = newIngredients2;
           
           let attr = _l[i].allAttributes;

           let _attr = this.$store.state.main.indx.attributes.ingredients;
           for (let k = 0; k < _attr.length; k++) {
             for (let j = 0; j < attr.length; j++) {
               if(attr[j] == _attr[k].id){
                n.push(_attr[k])

               }
               
             }
             
           }
         }
         return _l;
      },
    total() {},
    getDrinkPrice(){
         this.priceArr = [];
      this._contentData.forEach(d => {
        this.priceArr.push(d.price);
      })
      return this.priceArr;
    }
  },
  watch: {
    guestsIntensity() {}
  },

  methods: {
    getOrderVals(amount, title, id, price){
      let drink;
      let exists = this.orderedVals.find((item) => {
        return item.id == id;
      });
      if(exists){
      exists.amount = parseInt(amount);
      exists.price = parseFloat(price);
      // console.log(exists.price)
      } else {
        drink = {
        amount: parseInt(amount),
        title: title,
        id: id,
        price: parseFloat(price),
      }  
      this.orderedVals.push(drink);
      }
      
      // console.log(exists)
      // console.log(amount, title, id, price);
      // console.log(this.orderedVals);
    },
    openReceiptModal(idx){
      this.activeReceiptIdx = idx;
      this.$store.state.main.receiptActive = !this.$store.state.main.receiptActive;
      // console.log(this.activeReceiptIdx)
      
    },
    resizeWind(){
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
    toggleBarOrderModal(){
      if(this.totalDrinkPrice >= 600){
        this.$store.state.main.orderActive = !this.$store.state.main.orderActive
      }
      

    },
    toggleMode(){
      this.changeMode = !this.changeMode;
      this.$store.state.main.galleryTouch = !this.$store.state.main.galleryTouch;
      this.$store.state.main.changeMode = !this.$store.state.main.changeMode;
    },
    getAlcohol(idx){
      let list = [...this._contentData[idx].newIngredients.newArr];
   
      list = list.filter(l => l.slug == 'alcohol');

      
     if(this.$route.name === 'en' && list[0]){
        return list[0].descr_en
     } else if(this.$route.name === 'ge'&& list[0]) {
       return list[0].descr_ge;
     } else {
       return '...';
     };
    },
     getVolume(idx){
      let list = [...this._contentData[idx].newIngredients.newArr];
    
      list = list.filter(l => l.slug == 'volume');

      
      if(this.$route.name === 'en' && list[0]){
        return list[0].descr_en
     } else if(this.$route.name === 'ge'&& list[0]) {
       return list[0].descr_ge;
     } else {
       return '...';
     };
    },
         getGas(idx){
      let list = [...this._contentData[idx].newIngredients.newArr];
      
      list = list.filter(l => l.slug == 'gas');

      
     if(this.$route.name === 'en' && list[0]){
        return list[0].descr_en
     } else if(this.$route.name === 'ge'&& list[0]) {
       return list[0].descr_ge;
     } else {
       return '...';
     };
     
    },
    calcTotalDrinkPrice(drinkprice){
      let drinks = document.querySelectorAll(".drink input");
      let totalEachpriceArray = [];
      for (let i = 0; i < drinks.length; i++) {
        
     let totalEachPrice = Number.parseFloat(this.getDrinkPrice[i] * drinks[i].value).toFixed(2); 
     totalEachpriceArray.push(parseFloat(totalEachPrice));
    
      }
       this.totalDrinkPrice = Number.parseFloat(totalEachpriceArray.reduce((a, b) => a + b, 0)).toFixed(2);
    //  console.log(totalEachpriceArray)
      
    },
    increment(e){
      let rangeSliderVal =  e.currentTarget.parentElement.querySelector("input");
      const tooltip = e.currentTarget.parentElement.querySelector(".moved-track");
    var value = parseInt(rangeSliderVal.value, 10);
    value = isNaN(value) ? 0 : value;
if(this.guestsIntensity - this.sum > 0 && this.guestsIntensity - this.sum !== 0) value++;
   rangeSliderVal.value = value;
   this.calcBottles(rangeSliderVal);
  this.setToolTipVert(rangeSliderVal, tooltip);
      // console.log(rangeSliderVal)
    },
     decrement(e){
        let rangeSliderVal =  e.currentTarget.parentElement.parentElement.querySelector("input");
        const tooltip = e.currentTarget.parentElement.parentElement.querySelector(".moved-track");
            var value = parseInt(rangeSliderVal.value, 10);
          value = isNaN(value) ? 0 : value;
          value--;
         if(value >= 0) rangeSliderVal.value = value;
         if(value >= 0) this.sum = value;
           this.calcBottles(rangeSliderVal);

          this.setToolTipVert(rangeSliderVal, tooltip);
          //  console.log(rangeSliderVal.value);
           
    },



    incrementQ(e){
      let rangeSliderVal =  e.currentTarget.parentElement.querySelector("input");
    var value = parseInt(rangeSliderVal.value, 10);
    value = isNaN(value) ? 0 : value;
    if(value < rangeSliderVal.max) value++;
    this.guestVal = value;
    rangeSliderVal.value = value;
        const movedTrack = e.currentTarget.parentElement.querySelector(".track-wrapper .moved-track");
        const toolTip = e.currentTarget.parentElement.querySelector(".tool-tip");
      
      
        this.setToolTipPlus(rangeSliderVal, movedTrack);
        this.setToolTip(rangeSliderVal, toolTip)
        this.totalFuncGuest();
              this.totalFuncInt();
             this.yayOrNay();

      // console.log(this.guestVal)
    },
     decrementQ(e){
        let rangeSliderVal =  e.currentTarget.parentElement.  querySelector("input");
            var value = parseInt(rangeSliderVal.value, 10);
          value = isNaN(value) ? 0 : value;
        if(value > rangeSliderVal.min)  value--;
        rangeSliderVal.value = value;
          this.guestVal = value;
        const movedTrack = e.currentTarget.parentElement.querySelector(".track-wrapper .moved-track");
        const toolTip = e.currentTarget.parentElement.querySelector(".tool-tip");
        this.totalFuncGuest();
              this.totalFuncInt();
              this.yayOrNay();
           this.setToolTip(rangeSliderVal, toolTip)
           this.setToolTipPlus(rangeSliderVal, movedTrack);
          //  console.log(rangeSliderVal.value);
           
    },



     incrementQ2(e){
     
      let rangeSliderVal =  e.currentTarget.parentElement.querySelector("input");
     
    var value = parseInt(rangeSliderVal.value, 10);
    value = isNaN(value) ? 0 : value;
    if(value < rangeSliderVal.max) value++;
    this.durVal = value;
    rangeSliderVal.value = value;
        const movedTrack = e.currentTarget.parentElement.querySelector(".track-wrapper .moved-track");
        const toolTip = e.currentTarget.parentElement.querySelector(".tool-tip");
      
      
        this.setLineQ2(rangeSliderVal, movedTrack);
        this.setToolTip(rangeSliderVal, toolTip)
        this.totalFuncGuest();
              this.totalFuncInt();
             this.yayOrNay();

    },
     decrementQ2(e){
        
        let rangeSliderVal =  e.currentTarget.parentElement.querySelector("input");
            var value = parseInt(rangeSliderVal.value, 10);
          value = isNaN(value) ? 0 : value;
        if(value > rangeSliderVal.min)  value--;
        rangeSliderVal.value = value;
          this.durVal = value;
        const movedTrack = e.currentTarget.parentElement.querySelector(".track-wrapper .moved-track");
        const toolTip = e.currentTarget.parentElement.querySelector(".tool-tip");
        this.totalFuncGuest();
              this.totalFuncInt();
              this.yayOrNay();
           this.setToolTip(rangeSliderVal, toolTip)
           this.setLineQ2(rangeSliderVal, movedTrack);
           
    
    },


       incrementQ3(e){
     
      let rangeSliderVal =  e.currentTarget.parentElement.querySelector("input");
     
    var value = parseInt(rangeSliderVal.value, 10);
    value = isNaN(value) ? 0 : value;
    if(value < rangeSliderVal.max) value++;
    this.intensity = value;
    rangeSliderVal.value = value;
        const movedTrack = e.currentTarget.parentElement.querySelector(".track-wrapper .moved-track");
      
      
      
        this.setLineTri(rangeSliderVal, movedTrack);
      
        this.totalFuncGuest();
              this.totalFuncInt();
             this.yayOrNay();

    },
     decrementQ3(e){
        
        let rangeSliderVal =  e.currentTarget.parentElement.  querySelector("input");
            var value = parseInt(rangeSliderVal.value, 10);
          value = isNaN(value) ? 0 : value;
        if(value > rangeSliderVal.min)  value--;
        rangeSliderVal.value = value;
          this.intensity = value;
        const movedTrack = e.currentTarget.parentElement.querySelector(".track-wrapper .moved-track");
       
        this.totalFuncGuest();
              this.totalFuncInt();
              this.yayOrNay();
         
           this.setLineTri(rangeSliderVal, movedTrack);
           
    
    },




    getEachVal() {
      document.querySelectorAll(".drink input").forEach(i => {
        this.drinkAmount.push(i.value);
      });
    },

    setToolTip(range, bubble) {
      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;

  const newVal = Number(((val - min) * 100) / (max - min));
  parseInt(range.value) <= parseInt(range.max) ? bubble.style.left = `calc(${newVal}% + (${2 - newVal * 0.4}px))` : bubble.style.left = "calc(100% - 38px)";


    },

     setToolTipVert(range, bubble) {
      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;

  const
			newValue = Number( (range.value - range.min) * 100 / (range.max - range.min) ),
			newPosition = 10 - (newValue * 0.2);
		bubble.style.bottom = `calc(${newValue}% + (${newPosition}px))`;
    },

    setToolTipPlus(range, line) {
  
    const val = parseInt(range.value);
      const max = parseInt(range.max);

      let new_val = (val / max) * 100;
      line.style.width = `${new_val}%`;
      if(val >= max){
      line.style.width = `100%`;

      }
  
    },

    setLine(range, line) {
       const val = parseInt(range.value);
      const max = parseInt(range.max);

      let new_val = (val / max) * 100;
      line.style.width = `${new_val}%`;
      if(val >= max){
      line.style.width = `100%`;

      }
    },

     setLineQ2(range, line) {
       const val = parseInt(range.value);
      const max = parseInt(range.max);

      let new_val = (val / max) * 100;
      line.style.width = `${new_val - 3}%`;
      if(val >= max){
      line.style.width = `100%`;

      }
      
    },


      setLineTri(range, line) {
       const val = parseInt(range.value);
      const max = parseInt(range.max);

   
      if(val == 1){
        line.style.width = `0%`;
      } else  if(val == 2){
        line.style.width = `50%`;
      } else  if(val == 3){
        line.style.width = `100%`;
      }
      else if(val >= max){
      line.style.width = `100%`;

      }
    },

    changeTotalVal() {
      this.guestsIntensity = document.querySelector("#suggestion-input").value;
        // this.sum = this.guestsIntensity;
        this.sum = 0;
      document.querySelector(
        "#suggestion-input"
      ).value = document
        .querySelector("#suggestion-input")
        .value.replace(/\D/g, "");

          this.guestsIntensityDup = this.guestsIntensity;
         this.resetBottles();

          // this.totalFuncGuest();
          //     this.totalFuncInt();
          //     this.yayOrNay();
             
    },
    totalFuncGuest() {
      // if (this.durVal == 1) {
      //   this.guests = Math.round(this.guestVal * (3 * 1.5));
      //   this.durValOutput = 3;
      // } else if (this.durVal == 2) {
      //   this.guests = Math.round(this.guestVal * (6 * 1.5));
      //   this.durValOutput = 6;
      // } else if (this.durVal == 3) {
      //   this.guests = Math.round(this.guestVal * (12 * 1.5));
      //   this.durValOutput = 12;
      // }
      if(this.durVal <= 2){
        this.guests = Math.round(this.guestVal * (this.durVal * 1.3));
       
      } else if(this.durVal == 3 || this.durVal == 4){
        this.guests = Math.round(this.guestVal * ((this.durVal * 1.1 )* 1.3));
       
      } else if(this.durVal >= 5){
        this.guests = Math.round(this.guestVal * ((this.durVal * 0.85 )* 1.3));
        
      }
            this.durValOutput = this.durVal;
      
      this.resetBottles();
    },

    resetBottles(){
      this.sum = 0;
      this.maxBottles = [];
       this.drinkAmount = [];
       this.totalDrinkPrice = [];
       let bottles = document.querySelectorAll(".bottle-slider");
      for (let i = 0; i < bottles.length; i++) {
        this.drinkAmount.push(0);
        
      }
      bottles.forEach(b => {
       b.value = 0;
      //  console.log(b.value)
      });
      const tooltip = document.querySelectorAll(".drink .moved-track");
      tooltip.forEach(t => {
        t.style.bottom = "0";
      })
    },
    totalFuncInt() {
      if (this.intensity == 1) {
        this.guestsIntensity = Math.round(this.guests * 0.8);
        this.intensityOutput = "წრუპვა";
      } else if (this.intensity == 2) {
        this.guestsIntensity = Math.round(this.guests * 1);
        this.intensityOutput = "მხიარულება";
      } else if (this.intensity == 3) {
        this.guestsIntensity = Math.round(this.guests * 1.3);
        this.intensityOutput = "გალეშვა";
      }


       this.resetBottles();

    },

    yayOrNay() {
      if (this.picked === "არა") {
        this.guestsIntensity = this.guestsIntensity * 1;
      } else if (this.picked === "კი") {
        this.guestsIntensity = Math.round(this.guestsIntensity * 0.7);
      }
      this.guestsIntensityDup = this.guestsIntensity;
      this.resetBottles();
    },

    
    calcBottles(e) {
      let bottles = document.querySelectorAll(".bottle-slider");
      let bottlesInt = [];

      let total;
      // console.log(e.currentTarget)
      bottles.forEach(b => {
        let bValue = parseInt(b.value);
        bottlesInt.push(bValue);
        
        // console.log(bValue);
        b.disabled = false;
      });
      this.sum = bottlesInt.reduce(function(result, item) {
        return result + item;
      }, 0);


        this.maxBottles2 = 0;
        if(this.guestsIntensity - this.sum >= 0){
           this.maxBottles2 = this.guestsIntensity - this.sum;
        }
      //  console.log('maxbottles2   - ' + this.maxBottles2)
        
      // console.log(`დარჩენილია: ${this.guestsIntensity - this.sum}`);
      // console.log(`დარჩენილია: ${this.guestsIntensity - this.sum}`);

      if (this.sum + 1 > this.guestsIntensity) {
        bottles.forEach(bt => {
         bt.disabled = true;
        
          bt.disabled = false;

          if (this.sum > this.guestsIntensity) {
          }
        });
      }
      if (this.guestsIntensity - this.sum == 0) {
        
        this.maxBottles = [];

        bottles.forEach(b => {
          let bValue = parseInt(b.value);
          this.maxBottles.push(bValue);
        });
      }

      // console.log("max" + this.maxBottles);

    
         if (this.guestsIntensity - this.sum < 0) {
     
          let toPrev = parseInt(this.guestsIntensity - this.sum);
          // console.log('valuebeforprev' + e.target.value)
     e.target.value =  e.target.value - Math.abs(toPrev);
       
        //  console.log('toprev' + toPrev)
         
        
      }
       


      if (this.guestsIntensity - this.sum < 0) {
        for (let i = 0; i < bottles.length; i++) {

          
        }
      }

      this.drinkAmount = [];
      document.querySelectorAll(".drink input").forEach(i => {
        this.drinkAmount.push(i.value);
      });
    },

    getOldVal(e) {},
    preventBottles(e) {
      let bottles = document.querySelectorAll(".bottle-slider");
  
      //  console.log(e.target.value)
      if (this.guestsIntensity - this.sum == 0) {
       

        // console.log("old val");
      }
    },

    scrollStatus(e){
      if(e.target.classList.contains("bottle-slider") || e.target.classList.contains("slider")){
        this.$store.state.main.disableLsOnBar = !this.$store.state.main.disableLsOnBar;
        
        } else {
          this.$store.state.main.enableLsOnBar = !this.$store.state.main.enableLsOnBar;
        }
        // console.log(e.target)
    },
    scrollStatusOut(e){
      // console.log(e.target)
     if(!e.target.classList.contains("bottle-slider") || !e.target.classList.contains("slider"))this.$store.state.main.enableLsOnBar = !this.$store.state.main.enableLsOnBar;
    },
  },


  
};
</script>


<style lang="scss">
.from-right-enter-active,
.from-right-leave-active {
  transition: all 0.7s cubic-bezier(0.33, 1, 0.68, 1);
}
.from-right-enter{
    transform: translateX(100%);
}
.from-right-leave-to {
  transform: translateX(100%);
}
</style>
<style lang="scss" scoped>
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container {
  display: block;
  position: relative;
  padding-left: 45.5px;

  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
